import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_BG.json';
import exercises from './YOGA_EXERCISES_BG.json';
import recipes from './YOGA_RECIPES_BG.json';

export const YOGA_DATA_BG: ServiceData = {
  articles,
  exercises,
  recipes,
};
